import React, {Component} from "react";
import {ApiGet} from "../../../shared/services/api-service";
import {normalizeOitReport} from "../../services/analytics";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import FtoStatistics from "../analytics/FtoStatistics";
import Checkbox from "../../../shared/forms/Checkbox";
import Modal from "../../../shared/ui/Modal";

class DashboardStatisticsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selectedFtosGuids: [],
      reportAnalytics: [],
      selectedQuestionIds: [],
      selectedQuestions: {},
      selectedPhasesMap: {},
      selectedFormTypes: props.departmentSettings.ftoStatisticsFormTypes && props.departmentSettings.ftoStatisticsFormTypes.length
        ? props.departmentSettings.ftoStatisticsFormTypes
        : ['dor', 'dor2', 'dor3', 'dor3', 'rdor', 'dorr'],
      questionsSet: null,
      trainingPhases: [],
      showFormTypeModal: false
    }
  }

  componentDidMount() {
    this.setSelectedFtos(this.props.ftoGuids)

    if(this.props.forms && !this.state.questionsSet) {
      this.setState({
        selectedQuestions: this.addQuestionsToFilter(this.currentQuestions),
        questionsSet: true
      })
    }
    if(this.oitsInProgress.length) {
      let oit = this.oitsInProgress[0]
      this.setState({
        selectedPhasesMap: oit.trainingPhases
            .filter(tp => tp.type !== 'orientation')
            .reduce((acc, tp) => ({
              ...acc,
              [tp.sequence]: true
            }), {}),
        trainingPhases: oit.trainingPhases
      })
    }
  }


  get oitsInProgress() {
    return this.props.oits
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.forms && !this.state.questionsSet) {
      this.setState({
        selectedQuestions: this.addQuestionsToFilter(this.currentQuestions),
        questionsSet: true
      })
    }

    if(prevProps.ftoGuids.length !== this.props.ftoGuids.length) {
      this.setSelectedFtos(this.props.ftoGuids)
    }

    if(this.oitsInProgress.length && !this.state.trainingPhases.length) {
      let oit = this.oitsInProgress[0]
      this.setState({
        selectedPhasesMap: oit.trainingPhases
            .filter(tp => tp.type !== 'orientation')
            .reduce((acc, tp) => ({
              ...acc,
              [tp.sequence]: true
            }), {}),
        trainingPhases: oit.trainingPhases
      })
    }
  }


  setSelectedFtos(ftoIds) {
    this.setState({
      selectedFtosGuids: [...ftoIds]
    })
  }

  get selectedOits() {
    return this.state.reportAnalytics.map(({oitGuid}) => this.getOit(oitGuid))
  }

  get oitsInProgress() {
    return this.props.oits
      && this.props.oits.filter(o =>
        o.trainingPhases.find(tp => tp.status === 'opened'))
  }

  get selectedFtos() {
    return this.props.ftos ? this.props.ftos.filter(f => this.state.selectedFtosGuids.includes(f.guid)) : []
  }

  get critiqueFormTypes() {
    return this.props.departmentSettings && this.props.departmentSettings.critiqueFormTypes ? this.props.departmentSettings.critiqueFormTypes : ['ftc'];
  }

  get currentForms() {
    if(!this.props.forms) {
      return []
    }

    return this.props.forms
      .filter(f => f.status === 'current')
      .filter(f => {
        if (this.critiqueFormTypes.includes(f.type)) {
          return this.props.canViewCritiqueForms;
        }
        return true
      })
  }

  get currentQuestions() {
    return this.currentForms
      .filter(f => this.isFormTypeChecked(f))
      .reduce((acc, form) => {
        return [
          ...acc,
          ...form.layout.filter(q => q.type === 'question' && (q.schema.startsWith('rating') || q.schema === 'pto-rating-multi'))
        ]
      }, [])
  }

  get filteredQuestions() {
    return this.currentQuestions.filter(q => this.state.selectedQuestions[q.id])
  }

  isFormTypeChecked(form) {
    return this.state.selectedFormTypes.includes(form.type)
  }

  getOit(oitGuid) {
    return this.oitsInProgress.find(oit => oit.guid === oitGuid)
  }

  addQuestionsToFilter(questions) {
    return Object.assign(questions.reduce((acc, question) => ({
      ...acc,
      [question.id]: true
    }), {}), this.state.selectedQuestions)
  }

  handleFormTypeClick() {
    this.setState({
      showFormTypeModal: true
    });
  }

  closeFormTypeModal(e) {
    this.setState({
      showFormTypeModal: false
    });
  }

  onFormTypeSelectChange(checked, form) {
    let selectedFormTypes = [...this.state.selectedFormTypes];
    if(checked) {
      selectedFormTypes = [...selectedFormTypes.filter(f => f !== form.type), form.type];
    } else {
      selectedFormTypes = selectedFormTypes.filter(f => f !== form.type);
    }

    this.setState({
      selectedFormTypes
    })
  }

  render() {
    return (
      <div className="dashboard-statistics-report">

        {this.selectedFtos.length && this.filteredQuestions.length ? (
          <div>
            <div className="mr-2 mt-2">
              <button className="button secondary" onClick={() => this.handleFormTypeClick()}>
                <i className="fa fa-paperclip"/>
                Form types
              </button>
            </div>
            <div className="selected-users">
              <br/>
              <div style={{display: 'flex', flexWrap: 'wrap'}}>
                {this.state.trainingPhases
                    .filter(tp => tp.type !== 'orientation')
                    .map(tp => (
                        <div key={tp.sequence} style={{marginRight: '10px'}}>
                          <Checkbox
                              label={tp.header}
                              checked={this.state.selectedPhasesMap[tp.sequence]}
                              onChange={e => this.setState({selectedPhasesMap: {...this.state.selectedPhasesMap, [tp.sequence]: e.target.checked}})}
                          />
                        </div>
                    ))}
              </div>
            </div>
            <FtoStatistics
              selectedQuestions={this.filteredQuestions}
              selectedFtos={this.selectedFtos}
              selectedOits={this.selectedOits}
              selectedPhasesMap={this.state.selectedPhasesMap}
              formTypes={this.state.selectedFormTypes}
            />
          </div>
        ): null}
        <Modal
          fullscreen={true}
          title="Choose form types to display"
          isOpen={this.state.showFormTypeModal}
          onClose={(e) => this.closeFormTypeModal(e)}
          size="sm"
        >
          <div className="p-3">
            {this.currentForms.map(form => (
              <Checkbox
                key={form.type}
                checked={this.isFormTypeChecked(form)}
                label={form.name}
                onChange={(e) => {
                  this.onFormTypeSelectChange(e.target.checked, form)
                }}
              />
            ))}
            <div>
              <button className="button primary mt-3" onClick={() => this.closeFormTypeModal()}>
                Apply changes
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    ftos: state.ftos.list,
    viewingReport: state.reports.viewingReport,
    departmentSettings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    forms: state.forms.list,
    userContext: state.common.userContext
  };
}
export default connect(mapStateToProps)(DashboardStatisticsReport)
